module.exports = __webpack_public_path__ + "static/front/img/logo.8a7c657c.svg";